import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AUTH_TOKEN, AZIENDA_IN_USO, BINDING_ROLES, BINDING_ROLES_CONTABILITA, CENTRO_IN_USO, INIZIALIZZA_ROTTE, FOTO_PROFILO, INFO_USER, ROLE, VERSION_APP, BINDING_ROLES_COMPANY_STORES } from 'constants/AuthConstant';
import AuthService from 'services/AuthService';
import store from "../index";
import { loadPuntiVendita } from "./puntiVenditaSlice";
import packageJson from '../../../package.json';
import { loadCompany } from './companySlice';
import RoleService from 'services/RoleService';

export const initialState = {
    loading: false,
    message: '',
    showMessage: false,
    redirect: '',
    token: localStorage.getItem(AUTH_TOKEN) || null,
    ruolo: JSON.parse(localStorage.getItem(ROLE)) || null,
    user: JSON.parse(localStorage.getItem(INFO_USER)) || null,
    binding_roles: JSON.parse(localStorage.getItem(BINDING_ROLES)) || null,
    binding_role_user_companies: JSON.parse(localStorage.getItem(BINDING_ROLES_CONTABILITA)) || null,
    binding_role_company_stores: JSON.parse(localStorage.getItem(BINDING_ROLES_COMPANY_STORES)) || null,
    foto_profilo: JSON.parse(localStorage.getItem(FOTO_PROFILO)) || null,
    version_app: localStorage.getItem(VERSION_APP) || null,
    centro_in_uso: localStorage.getItem(CENTRO_IN_USO) || 'centro_medico',
    azienda_in_uso: JSON.parse(localStorage.getItem(AZIENDA_IN_USO)) || null,
    inizializza_rotte: localStorage.getItem(INIZIALIZZA_ROTTE) === 'true' || false
}

export const signIn = createAsyncThunk('auth/login', async (data, { rejectWithValue }) => {
    console.log("[signIn]");

    const { email, password } = data
    try {
        let data = {
            "identifier": email, "password": password
        }

        //RECUPERO JWT + INFO USER
        const response = await AuthService.login(data)

        const { jwt, user } = response
        localStorage.setItem(AUTH_TOKEN, jwt);
        localStorage.setItem(INFO_USER, JSON.stringify(user));

        //RECUPERO ROLE
        let response_role = await AuthService.getRole();
        const response_foto_profilo = await AuthService.getFotoProfilo();
        response_role.foto_profilo = response_foto_profilo['foto_profilo']
        const ruolo = response_role;
        console.log("ale-patient-associazione ruolo", ruolo)
        let queryString = ''
        let responseBind = ''
        let uniqueCompanies = []
        for (let i = 0; i < ruolo.binding_roles.length; i++) {
            queryString += '&filters[store][documentId]=' + ruolo.binding_roles[i].store.documentId
        }

        if (queryString.length != 0) {
            console.log("queryString", queryString)

            responseBind = await RoleService.getBindingRolesCompanyStoresFilters(queryString)
            console.log("ale-patient-associazione responseBind", responseBind)
            console.log("responseBind", responseBind)
            uniqueCompanies = Array.from(
                new Map(
                    responseBind.data.map(item => [item.attributes.store.data.documentId, item.attributes.store.data])
                ).values()
            );
            // Usa i dati filtrati
            console.log(uniqueCompanies);
            console.log("ale-patient-associazione uniqueCompanies", uniqueCompanies)
        }

        //RECUPERO I PUNTI VENDITA A ME ASSOCIATI
        store.dispatch(loadPuntiVendita(response_role));
        store.dispatch(loadCompany(response_role));

        localStorage.setItem(ROLE, JSON.stringify(ruolo.role));
        localStorage.setItem(BINDING_ROLES, ruolo.binding_roles ? JSON.stringify(ruolo.binding_roles) : []);
        localStorage.setItem(BINDING_ROLES_CONTABILITA, ruolo.binding_role_user_companies ? JSON.stringify(ruolo.binding_role_user_companies) : []);
        localStorage.setItem(BINDING_ROLES_COMPANY_STORES, uniqueCompanies.length !== 0 ? JSON.stringify(uniqueCompanies) : []);
        localStorage.setItem(FOTO_PROFILO, JSON.stringify(ruolo.foto_profilo));
        localStorage.setItem(VERSION_APP, packageJson.version);
        localStorage.setItem(INIZIALIZZA_ROTTE, true);

        let auth = {}
        auth.jwt = jwt;
        auth.ruolo = ruolo.role;
        auth.user = user;
        auth.binding_roles = ruolo.binding_roles ? ruolo.binding_roles : [];
        auth.binding_role_user_companies = ruolo.binding_role_user_companies ? ruolo.binding_role_user_companies : [];
        auth.binding_role_company_stores = uniqueCompanies.length !== 0 ? uniqueCompanies : []
        auth.version_app = packageJson.version;
        auth.inizializza_rotte = true;
        const nameRuolo = auth.ruolo.name;

        // GESTIONE DEL CENTRO
        if (nameRuolo === 'superadmin' || nameRuolo === 'operatore' || nameRuolo === 'operatore_contabile') {
            auth.centro_in_uso = 'centro_medico';
            localStorage.setItem(CENTRO_IN_USO, 'centro_medico');
        } else if (nameRuolo === 'operatore_contabile' || nameRuolo === 'contabile') {
            auth.centro_in_uso = 'centro_contabile';
            localStorage.setItem(CENTRO_IN_USO, 'centro_contabile');
        }

        //QUI FACCIO TUTTE LE CHIAMATE DI INIZALIZZAZIONE DEL SOFTWARE
        console.table(auth)
        return {
            jwt: jwt,
            role: ruolo.role,
            user: user,
            binding_roles: ruolo.binding_roles,
            binding_role_user_companies: ruolo.binding_role_user_companies,
            binding_role_company_stores: auth.binding_role_company_stores,
            foto_profilo: ruolo.foto_profilo,
            centro_in_uso: auth.centro_in_uso,
            inizializza_rotte: auth.inizializza_rotte
        };
    } catch (err) {
        console.log("err", err)
        //return rejectWithValue(err?.message || 'Error')
        localStorage.clear();

        return rejectWithValue('Autenticazione fallita')
    }
})

export const reloadRole = createAsyncThunk('auth/reloadRole', async (data, { rejectWithValue }) => {
    console.log("[reloadRole]");

    try {
        //RECUPERO ROLE
        const response_role = await AuthService.getRole();
        const ruolo = response_role

        let queryString = ''
        let uniqueCompanies = []
        let responseBind = ''

        for (let i = 0; i < ruolo.binding_roles.length; i++) {
            queryString += '&filters[store][documentId]=' + ruolo.binding_roles[i].store.documentId
        }

        if (queryString.length != 0) {
            console.log("queryString", queryString)

            responseBind = await RoleService.getBindingRolesCompanyStoresFilters(queryString)
            console.log("responseBind", responseBind)
            uniqueCompanies = Array.from(
                new Map(
                    responseBind.data.map(item => [item.attributes.store.data.documentId, item.attributes.store.data])
                ).values()
            );
            // Usa i dati filtrati
            console.log(uniqueCompanies);
        }

        //RECUPERO I PUNTI VENDITA A ME ASSOCIATI
        store.dispatch(loadPuntiVendita(response_role));
        store.dispatch(loadCompany(response_role));

        localStorage.setItem(ROLE, JSON.stringify(ruolo.role));
        localStorage.setItem(BINDING_ROLES, JSON.stringify(ruolo.binding_roles));
        localStorage.setItem(BINDING_ROLES_COMPANY_STORES, uniqueCompanies.length !== 0 ? JSON.stringify(uniqueCompanies) : []);
        localStorage.setItem(BINDING_ROLES_CONTABILITA, ruolo.binding_role_user_companies ? JSON.stringify(ruolo.binding_role_user_companies) : []);
        //RECUPERO I PUNTI VENDITA A ME ASSOCIATI

        let auth = {}
        auth.ruolo = ruolo.role;
        auth.binding_roles = ruolo.binding_roles;
        auth.binding_role_company_stores = uniqueCompanies.length !== 0 ? uniqueCompanies : [];
        auth.binding_role_user_companies = ruolo.binding_role_user_companies ? ruolo.binding_role_user_companies : [];
        console.table(auth)
        return {
            role: ruolo.role,
            binding_roles: ruolo.binding_roles,
            binding_role_user_companies: ruolo.binding_role_user_companies,
            binding_role_company_stores: auth.binding_role_company_stores
        };
    } catch (err) {
        console.log("err", err)
        return rejectWithValue('Errore')
    }
})

export const signUp = createAsyncThunk('auth/register', async (data, { rejectWithValue }) => {
    const { email, password } = data
    try {
        const response = await AuthService.register({ email, password })
        const token = response.data.token;
        localStorage.setItem(AUTH_TOKEN, token);
        return token;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const signOut = createAsyncThunk('auth/logout', async () => {
    //const response = await FirebaseService.signOutRequest()
    localStorage.clear();

    /*
    localStorage.removeItem(auth_token);
    localStorage.removeItem(INFO_USER);
    localStorage.removeItem(ROLE);

     */
    // return response.data
})


export const changeCentro = createAsyncThunk('auth/cambiaCentro', async (data, { rejectWithValue }) => {
    console.log("[changeCentro]", data);


    try {
        const centro_in_uso = data.centro_in_uso;
        const azienda_in_uso = data.azienda_in_uso;
        localStorage.setItem(CENTRO_IN_USO, (centro_in_uso));
        localStorage.setItem(AZIENDA_IN_USO, JSON.stringify(azienda_in_uso));
        localStorage.setItem(INIZIALIZZA_ROTTE, true);
        return {
            centro_in_uso: centro_in_uso,
            azienda_in_uso: azienda_in_uso,
            inizializza_rotte: true
        };

    } catch (err) {
        console.log("err", err)
        return rejectWithValue('Errore')
    }
})

export const disableRefreshRotte = createAsyncThunk('auth/disableRefreshRotte', async (data, { rejectWithValue }) => {
    console.log("[disableRefreshRotte]");

    try {
        localStorage.setItem(INIZIALIZZA_ROTTE, false);
        return {
            inizializza_rotte: false
        };

    } catch (err) {
        console.log("err", err)
        return rejectWithValue('Errore')
    }
})

export const signInWithGoogle = createAsyncThunk('auth/signInWithGoogle', async (_, { rejectWithValue }) => {
    try {
        const response = await AuthService.loginInOAuth()
        const token = response.data.token;
        localStorage.setItem(AUTH_TOKEN, token);
        return token;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const signInWithFacebook = createAsyncThunk('auth/signInWithFacebook', async (_, { rejectWithValue }) => {
    try {
        const response = await AuthService.loginInOAuth()
        const token = response.data.token;
        localStorage.setItem(AUTH_TOKEN, token);
        return token;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})


export const authSlice = createSlice({
    name: 'auth', initialState, reducers: {
        updateUser: (state, action) => {
            const { updatedFields } = action.payload;
            console.log("updatedFields", updatedFields);
            console.log("auth prima", state.auth);

            if ('foto_profilo' in updatedFields) {
                state.foto_profilo = updatedFields.foto_profilo
                localStorage.setItem(FOTO_PROFILO, JSON.stringify(updatedFields.foto_profilo));

            } else {
                // Altrimenti, mantieni invariato lo stato attuale di auth
                state.auth = { ...state.auth };
            }

            console.log("auth dopo", state.auth);
        }, authenticated: (state, action) => {
            state.loading = false
            state.redirect = '/'
            state.token = action.payload
        }, showAuthMessage: (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        }, hideAuthMessage: (state) => {
            state.message = ''
            state.showMessage = false
        }, signOutSuccess: (state) => {
            state.loading = false
            state.token = null
            state.redirect = '/'
        }, showLoading: (state) => {
            state.loading = true
        }, signInSuccess: (state, action) => {
            state.loading = false
            state.token = action.payload
        }
    }, extraReducers: (builder) => {
        builder
            .addCase(signIn.pending, (state) => {
                state.loading = true
            })
            .addCase(signIn.fulfilled, (state, action) => {
                state.loading = false
                state.redirect = '/'
                state.token = action.payload.jwt
                state.ruolo = action.payload.role
                state.user = action.payload.user
                state.foto_profilo = action.payload.foto_profilo
                state.binding_roles = action.payload.binding_roles
                state.binding_role_user_companies = action.payload.binding_role_user_companies
                state.binding_role_company_stores = action.payload.binding_role_company_stores
                state.version_app = packageJson.version;
                state.centro_in_uso = action.payload.centro_in_uso;
                state.inizializza_rotte = action.payload.inizializza_rotte;

            })
            .addCase(signIn.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(changeCentro.pending, (state) => {
                state.loading = true
            })
            .addCase(changeCentro.fulfilled, (state, action) => {
                state.loading = false
                state.centro_in_uso = action.payload.centro_in_uso;
                state.azienda_in_uso = action.payload.azienda_in_uso;
                state.inizializza_rotte = action.payload.inizializza_rotte;
            })
            .addCase(changeCentro.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                localStorage.removeItem(CENTRO_IN_USO)
                localStorage.removeItem(AZIENDA_IN_USO)
                localStorage.removeItem(INIZIALIZZA_ROTTE)
            })
            .addCase(signOut.fulfilled, (state) => {
                state.loading = false
                state.token = null
                state.redirect = '/'
                localStorage.clear();

            })
            .addCase(signOut.rejected, (state) => {
                state.loading = false
                state.token = null
                state.redirect = '/'
                localStorage.clear();

            })
            .addCase(signUp.pending, (state) => {
                state.loading = true
            })
            .addCase(signUp.fulfilled, (state, action) => {
                state.loading = false
                state.redirect = '/'
                state.token = action.payload
            })
            .addCase(signUp.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(signInWithGoogle.pending, (state) => {
                state.loading = true
            })
            .addCase(signInWithGoogle.fulfilled, (state, action) => {
                state.loading = false
                state.redirect = '/'
                state.token = action.payload
            })
            .addCase(signInWithGoogle.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(signInWithFacebook.pending, (state) => {
                state.loading = true
            })
            .addCase(signInWithFacebook.fulfilled, (state, action) => {
                state.loading = false
                state.redirect = '/'
                state.token = action.payload
            })
            .addCase(signInWithFacebook.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(reloadRole.pending, (state) => {
                state.loading = true
            })
            .addCase(reloadRole.fulfilled, (state, action) => {
                state.loading = false
                state.ruolo = action.payload.role
                state.binding_roles = action.payload.binding_roles
                state.binding_role_user_companies = action.payload.binding_role_user_companies;
                state.binding_role_company_stores = action.payload.binding_role_company_stores;
            })
            .addCase(reloadRole.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(disableRefreshRotte.pending, (state) => {
                state.loading = true
            })
            .addCase(disableRefreshRotte.fulfilled, (state, action) => {
                state.loading = false
                state.inizializza_rotte = action.payload.inizializza_rotte;
            })
            .addCase(disableRefreshRotte.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })

    },
})

export const {
    authenticated, showAuthMessage, hideAuthMessage, signOutSuccess, showLoading, updateUser,
} = authSlice.actions

export default authSlice.reducer